import React, {ReactNode} from "react";

type Props = {
    options: Record<string, ReactNode>,
    value: string,
    name: string,
    title?: ReactNode,
    onChange?: (key: string) => void,
    disabled?: boolean,
}

export default function Radio({options, value, title, name, onChange, disabled}: Props) {
    return <div className='form-group'>
        { title && <label className='form-label'>{title}</label> }
        {
            Object.entries(options).map(([key, displayValue]) => <label className='form-radio' key={key}>
                <input
                    type='radio' value={key} name={name} checked={value === key} disabled={disabled}
                    onChange={e => e.target.checked && onChange?.(e.target.value)} />
                <i className='form-icon'></i> {displayValue}
            </label>)
        }
    </div>
}
